import { IPreview } from '../../dropzone.types';
import { truncateFilename } from '../../helpers';
import {
  FileNameDisplay,
  ImagePreviewContainer,
  StyledImage,
} from './imagePreview.styles';

const ImagePreview = ({ preview }: { preview: IPreview }) => {
  if (preview.type === 'image') {
    return <StyledImage src={preview.url} />;
  }

  return (
    <ImagePreviewContainer>
      <FileNameDisplay>{truncateFilename(preview.name, 16)}</FileNameDisplay>
    </ImagePreviewContainer>
  );
};

export default ImagePreview;
